import React, { useCallback, useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { apiUrl, fetchJson } from '../../apiBase';

export default function ParentIntroductions({ schoolId }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    if (!schoolId) return;
    setLoading(true);
    try {
      const response = await fetchJson(apiUrl(`/admin/parent-introductions/${encodeURIComponent(schoolId)}`));
      const body = await response.json();
      if (!response.ok) throw new Error(body.detail || 'Talepler alınamadı.');
      setItems(body.items || []);
      setError('');
    } catch (cause) {
      setError(cause.message);
    } finally {
      setLoading(false);
    }
  }, [schoolId]);

  useEffect(() => { load(); }, [load]);

  const markContacted = async (id) => {
    setBusyId(id);
    try {
      const response = await fetchJson(apiUrl(`/admin/parent-introductions/${encodeURIComponent(schoolId)}/${id}/contacted`), { method: 'POST' });
      const body = await response.json();
      if (!response.ok) throw new Error(body.detail || 'Talep güncellenemedi.');
      setItems((current) => current.map((item) => item.id === id ? body : item));
      setError('');
    } catch (cause) {
      setError(cause.message);
    } finally {
      setBusyId(null);
    }
  };

  return <Stack spacing={2}>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="h5">Veli Tanışma Talepleri</Typography>
      <Button onClick={load}>Yenile</Button>
    </Stack>
    {error && <Alert severity="error">{error}</Alert>}
    {loading && <CircularProgress size={24} />}
    {!loading && items.length === 0 && <Typography>Henüz tanışma talebi yok.</Typography>}
    {!loading && items.map((item) => <Paper key={item.id} variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={1}>
        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" gap={1}>
          <Typography variant="h6">{item.parent_first_name} {item.parent_last_name}</Typography>
          <Chip size="small" color={item.status === 'new' ? 'info' : 'success'} label={item.status === 'new' ? 'Yeni' : 'İletişime Geçildi'} />
        </Stack>
        <Typography><a href={`tel:${item.contact_phone}`}>{item.contact_phone}</a></Typography>
        <Typography variant="body2" color="text.secondary">{new Date(item.created_at).toLocaleString('tr-TR')}</Typography>
        <Box>{(item.students || []).map((student, index) => <Typography key={index}>{student.first_name} {student.last_name} — {student.grade_level}</Typography>)}</Box>
        <Typography><strong>İlk mesaj:</strong> {item.first_message || '—'}</Typography>
        {item.parent_note && <Typography><strong>Veli notu:</strong> {item.parent_note}</Typography>}
        {item.status === 'new' && <Box><Button variant="outlined" disabled={busyId === item.id} onClick={() => markContacted(item.id)}>İletişime geçildi olarak işaretle</Button></Box>}
      </Stack>
    </Paper>)}
  </Stack>;
}
